module.exports = __webpack_public_path__ + "static/img/tooltip-constellation-revisit-metrics.0a6e0b2.png";